import { Link } from "react-router-dom";
import LegalLayout from "./LegalLayout";

export default function Refund() {
  return (
    <LegalLayout title="Refund Policy" updated="June 22, 2026">
      <div className="legal-callout">
        We stand behind our software. If something isn't working right on our end, we'll make it right.
      </div>

      <h2>1. Subscription cancellations</h2>
      <h3>Monthly plans</h3>
      <p>You may cancel your monthly subscription at any time. Cancellation takes effect at the end of your current billing period. You will retain access to the Service until that date. We do not issue prorated refunds for partial months.</p>
      <h3>Annual plans</h3>
      <p>You may cancel your annual subscription at any time. If you cancel within <strong>14 days</strong> of your initial purchase or annual renewal date, you are eligible for a full refund of subscription fees paid. After 14 days, no refund is issued for the remainder of the annual term, but you retain access until the period ends.</p>

      <h2>2. Setup fees — no refund</h2>
      <p><strong>Setup fees are non-refundable under all circumstances.</strong> This includes onboarding fees, implementation fees, and any other one-time charges associated with getting your account configured and activated.</p>
      <p>If you have elected to pay your setup fee in <strong>6 monthly installments</strong>, cancellation does not relieve you of the obligation to pay the remaining balance. Upon cancellation, all outstanding installments become immediately due and will be charged to your payment method on file. You will receive written notice of the amount owed before the charge is processed.</p>

      <h2>3. Refund eligibility summary</h2>
      <table>
        <thead><tr><th>Situation</th><th>Outcome</th></tr></thead>
        <tbody>
          <tr><td>Cancel annual subscription within 14 days of purchase/renewal</td><td>Full refund of subscription fees only</td></tr>
          <tr><td>Cancel monthly subscription mid-cycle</td><td>No refund; access until period end</td></tr>
          <tr><td>Cancel annual subscription after 14 days</td><td>No refund; access until period end</td></tr>
          <tr><td>Setup fee (any plan)</td><td>Non-refundable</td></tr>
          <tr><td>Setup fee 6-month installment plan — cancellation mid-term</td><td>Remaining balance charged immediately</td></tr>
          <tr><td>Service outage exceeding SLA (if applicable)</td><td>Account credit (see Section 5)</td></tr>
          <tr><td>Duplicate charge or billing error</td><td>Full refund of erroneous amount</td></tr>
          <tr><td>Unauthorized charge (fraud)</td><td>Full refund after verification</td></tr>
        </tbody>
      </table>

      <h2>4. Free trials</h2>
      <p>Free trials are not charged. If you cancel before the trial ends, you will not be billed. If your trial converts to a paid plan and you cancel within 14 days of the first charge, you are eligible for a refund of subscription fees under Section 1. Setup fees remain non-refundable.</p>

      <h2>5. Service credits</h2>
      <p>If the Service experiences significant downtime or a material failure attributable to ordrsAI (beyond what is described in our Terms of Service), we may issue account credits at our discretion. Credits are applied to your next billing cycle, are non-transferable, and have no cash value.</p>

      <h2>6. Non-refundable items</h2>
      <ul>
        <li>Setup fees of any kind (onboarding, implementation)</li>
        <li>Remaining installments on a 6-month setup fee plan upon cancellation</li>
        <li>Usage fees for API calls or compute beyond included limits</li>
        <li>Subscriptions cancelled after the 14-day window</li>
        <li>Accounts terminated for violation of our Terms of Service</li>
      </ul>

      <h2>7. How to request a refund</h2>
      <p>Email <a href="mailto:support@ordrs.ai">support@ordrs.ai</a> with the subject line "Refund request" and include:</p>
      <ul>
        <li>Your account email address</li>
        <li>The charge date and amount</li>
        <li>Reason for the request</li>
      </ul>
      <p>We will respond within <strong>3 business days</strong>. Approved refunds are returned to your original payment method within <strong>5–10 business days</strong>, depending on your payment provider.</p>

      <h2>8. Disputes</h2>
      <p>If you believe a refund decision was incorrect, reply to our response email with additional context. We will review and respond within 5 business days. If we cannot reach an agreement, you may pursue remedies through your payment provider or applicable consumer protection channels.</p>

      <h2>9. Changes to this policy</h2>
      <p>We may update this policy from time to time. Changes are effective when posted. Continued use of the Service constitutes acceptance.</p>

      <h2>10. Contact</h2>
      <p>ordrsAI · <a href="mailto:support@ordrs.ai">support@ordrs.ai</a> · See also our <Link to="/terms">Terms of Service</Link>.</p>
    </LegalLayout>
  );
}
